import React from 'react';

import type { LaneMode } from '../../../apis/lanePlanner';
import { carrierInitials } from '../../../common/utils/providerLogo';
import CarrierBadge from './CarrierBadge';
import ModeIcon from './ModeIcon';
import styles from './styles.module.css';

/** A carrier's logo (or initials) in a circle, with its mode's glyph at the bottom right. `className` sizes and places it. */
const CarrierChip: React.FC<{
  mode: LaneMode;
  logoUrl?: string | null;
  carrier?: string | null;
  className?: string;
  glyphSize?: number;
}> = ({ mode, logoUrl, carrier, className, glyphSize = 10 }) => (
  <span
    className={[styles.chip, className].filter(Boolean).join(' ')}
    role='img'
    aria-label={carrier ? `${carrier}, ${mode}` : mode}
  >
    {logoUrl ? (
      <img
        src={logoUrl}
        alt=''
        className={styles.chipLogo}
        onError={(e) => {
          (e.target as HTMLImageElement).style.display = 'none';
        }}
      />
    ) : (
      carrier &&
      carrierInitials(carrier) && (
        <CarrierBadge name={carrier} mode={mode} className={styles.chipBadge} />
      )
    )}
    <span className={styles.chipMode}>
      <ModeIcon mode={mode} size={glyphSize} />
    </span>
  </span>
);

export default CarrierChip;
